/* unplugin-vue-components disabled */import { render } from "./peopleManagement.vue?vue&type=template&id=3d4fa6b6&scoped=true"
import script from "./peopleManagement.vue?vue&type=script&lang=js"
export * from "./peopleManagement.vue?vue&type=script&lang=js"

import "./peopleManagement.vue?vue&type=style&index=0&id=3d4fa6b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4fa6b6"]])

export default __exports__